export default __webpack_public_path__ + "static/media/laundry2-beforeB-1024w.313e1d0b.avif";